import React, { useContext, useState } from "react";
import Footer from "./components/Footer";
import styles from "./Login.module.css";
import { AuthContext, AuthErrors } from "../../context/AuthContext";
import ErrorText from "../../components/ErrorText";
import { useTranslation } from "react-i18next";
import Checkbox from "./components/Checkbox";
import InputBox, {
  InputBoxRoundedCornors,
  InputBoxState,
} from "../../components/InputBox";
import StylePack from "../../util/StylePack.js";
import { JokerButton, ButtonType, ButtonSize } from "material-ui-jokerpro";
import { isValidPassword, isValidUsername } from "../../util/Validator";
import MainTemplate from "../Templates/MainTemplate";

const Login = () => {
  enum AuthErrorCause {
    InvalidUsername = 3,
    InvalidPassword = 4,
    IncorrectPassword = 5,
  }

  const { t } = useTranslation();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { login, logout, authErrors } = useContext(AuthContext);

  const handleLogin = async () => {
    login(username, password);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    logout();
    handleLogin();
  };

  const getUsernameInputStatus = (
    value: string,
    authErrors: AuthErrors | undefined
  ): InputBoxState => {
    if (value.length === 0) return InputBoxState.default;
    if (!isValidUsername(value)) return InputBoxState.error;
    if (authErrors && authErrors.data.status == AuthErrorCause.InvalidUsername)
      return InputBoxState.error;
    return InputBoxState.success;
  };

  const getPasswordInputStatus = (
    value: string,
    authErrors: AuthErrors | undefined
  ): InputBoxState => {
    if (value.length === 0) return InputBoxState.default;
    if (!isValidPassword(value)) return InputBoxState.error;
    if (
      authErrors &&
      [
        AuthErrorCause.InvalidPassword,
        AuthErrorCause.IncorrectPassword,
      ].includes(authErrors.data.status)
    )
      return InputBoxState.error;
    return InputBoxState.success;
  };

  const userNameState = getUsernameInputStatus(username, authErrors);
  const passwordState = getPasswordInputStatus(password, authErrors);

  var body = (
    <div className={styles["login-container"]}>
      <form className={styles["login-form"]} onSubmit={handleSubmit}>
        <h2>{t("login_page.title")}</h2>
        <InputBox
          roundedCornors={InputBoxRoundedCornors.top}
          state={userNameState}
          type="text"
          placeholder={t("username")}
          value={username}
          onChange={(e: any) => setUsername(e.target.value)}
        />

        <InputBox
          onClick={handleSubmit}
          roundedCornors={InputBoxRoundedCornors.bottom}
          state={passwordState}
          type="password"
          placeholder={t("password")}
          value={password}
          onChange={(e: any) => setPassword(e.target.value)}
        />

        {authErrors && <ErrorText>{`${authErrors.data.error}`}</ErrorText>}

        <div className={styles["login-actions"]}>
          <Checkbox text={t("remember_me")} />
          <JokerButton
            text={t("forgot_password")}
            href={"/reset_password"}
            type={ButtonType.Link}
            size={ButtonSize.Normal}
            underlined
          />
        </div>
        <p>{t("login_page.dont_have_account")}</p>
        <JokerButton
          text={t("login_page.create_account_now")}
          href={"/sign_up"}
          type={ButtonType.Link}
          highlighted
          underlined
        />
      </form>
    </div>
  );

  return (
    <MainTemplate
      body={body}
      footer={<Footer />}
      backgroundStyle={StylePack.BACKGROUND_LOGIN_STYLE}
      hasOverlayFooter
    />
  );
};

export default Login;
